const angular = require('angular');
const app = angular.module('learn-directives');
/**
 * Defines the Google picker component
 * @argument {Application} Application injected to gain access to the global Application functions and properties
 */
app.directive('googlePicker', ['Application', 'Authorization', function (Application, Authorization) {
  return {
    restrict: 'A',
    replace: false,
    scope: {
      type: '@',
      onSelect: '&'
    },
    link: function (scope, element, attrs) {
      var user = Authorization.getAuthToken().user;

      var developerKey = 'AIzaSyCUPX6chA6xVeIBKDVxp0vR_34nz3a0sqE';
      var clientId = "826351200963-8k83ddn81u215brml4rrfe6eunldg9b3.apps.googleusercontent.com";
      var scopeRequest = ['https://www.googleapis.com/auth/drive', 'https://www.googleapis.com/auth/drive.file', 'https://www.googleapis.com/auth/drive.readonly'];
      var pickerApiLoaded = false;
      var views = [];
      var oauthToken;

      function handleAuthResult(authResult) {
        if (authResult && !authResult.error) {
          oauthToken = authResult.access_token;
          createPicker();
        }
      };

      function onAuthApiLoad() {
        setTimeout(function() {
          window.gapi.auth.authorize(
            {
              'client_id': clientId,
              'scope': scopeRequest,
              'immediate': false
            },
            handleAuthResult
          );
          
        }, 500);
      };

      function onPickerApiLoad() {
        switch (scope.type) {
          case 'file':
            views = [google.picker.ViewId.DOCUMENTS, google.picker.ViewId.PDFS, google.picker.ViewId.PRESENTATIONS, google.picker.ViewId.SPREADSHEETS];
            break;
          case 'video':
            views = [google.picker.ViewId.DOCS_VIDEOS];
            break;
          default:
            views = [google.picker.ViewId.DOCUMENTS];
            break;
        }

        pickerApiLoaded = true;
        createPicker();
      };

      // Create and render a Picker object for picking user Photos.
      function createPicker() {
        if (pickerApiLoaded && oauthToken) {
          if (scope.type === 'file') {
            var picker = new google.picker.PickerBuilder().
            addView(views[0]).
            addView(views[1]).
            addView(views[2]).
            addView(views[3]).
            setOAuthToken(oauthToken).
              setDeveloperKey(developerKey).
              setCallback(pickerCallback).
              build();
          }
          if (scope.type === 'video') {
            var picker = new google.picker.PickerBuilder().
            addView(views[0]).
            setOAuthToken(oauthToken).
              setDeveloperKey(developerKey).
              setCallback(pickerCallback).
              build();
          }

          picker.setVisible(true);
        }
      };

      // A simple callback implementation.
      function pickerCallback(data) {
        var id = null;
        if (data[google.picker.Response.ACTION] == google.picker.Action.PICKED) {
          var doc = data[google.picker.Response.DOCUMENTS][0];
          id = doc[google.picker.Document.ID];
        }
        if (!id) {
          return;
        }
        if (scope.type === 'file') {
          if (doc[google.picker.Document.MIME_TYPE] === 'application/pdf') {
            scope.onSelect({url: 'https://www.googleapis.com/drive/v3/files/' + id + '?alt=media', token: oauthToken});
            return;
          }
          scope.onSelect({url: 'https://www.googleapis.com/drive/v3/files/' + id + '/export?mimeType=application/pdf', token: oauthToken});
        }

        if (scope.type === 'video') {
          if (doc[google.picker.Document.SQ] > 1024000000) {
            Application.messaging.addMessage({type: 'error', duration: 6, text: 'This video exceeds the 1024mb limit.'});
            scope.$apply();
            return;
          }
          scope.onSelect({url: 'https://www.googleapis.com/drive/v3/files/' + id + '?alt=media', token: oauthToken, name: doc[google.picker.Document.NAME], mimeType: doc[google.picker.Document.MIME_TYPE], sizeBytes: doc[google.picker.Document.SQ]});
        }
      };

      var initialize = function() {
        if (!window.gapi) {
          var script = document.createElement('script');
          script.onload = function() {
            window.gapi.load('auth', {'callback': onAuthApiLoad});
            window.gapi.load('picker', {'callback': onPickerApiLoad});
            scope.$apply();
          }
          script.src = "https://apis.google.com/js/api.js";
          document.head.appendChild(script);
          return;
        }

        window.gapi.load('auth', {'callback': onAuthApiLoad});
        window.gapi.load('picker', {'callback': onPickerApiLoad});
      };

      element.bind('click', initialize);
    }
  };
}]);